import React from 'react';

/**
 * Decorative section divider — minimal, elegant, theme-aware.
 * Uses a centered diamond/dot motif over a hairline gradient line.
 *
 * Props:
 *   variant: 'light' (default white bg) | 'dark' (slate-950 bg)
 */
const SectionDivider = ({ variant = 'light' }) => {
  const isDark = variant === 'dark';
  return (
    <div className={isDark ? 'bg-slate-950' : 'bg-white'}>
      <div className="max-w-3xl mx-auto px-6 py-10 sm:py-14 flex items-center gap-4">
        <div
          className={`flex-1 h-px bg-gradient-to-r from-transparent ${
            isDark ? 'via-slate-700' : 'via-slate-300'
          } to-transparent`}
        />
        <div className="flex items-center gap-2">
          <span
            className={`w-1 h-1 rounded-full ${
              isDark ? 'bg-cyan-400/40' : 'bg-cyan-500/50'
            }`}
          />
          <span
            className={`w-1.5 h-1.5 rotate-45 ${
              isDark ? 'bg-cyan-400/70' : 'bg-cyan-500'
            }`}
          />
          <span
            className={`w-1 h-1 rounded-full ${
              isDark ? 'bg-cyan-400/40' : 'bg-cyan-500/50'
            }`}
          />
        </div>
        <div
          className={`flex-1 h-px bg-gradient-to-r from-transparent ${
            isDark ? 'via-slate-700' : 'via-slate-300'
          } to-transparent`}
        />
      </div>
    </div>
  );
};

export default SectionDivider;
